import { z } from "zod"

export const BackofficeShopifyMetafieldsAuditBodySchema = z.object({
  companyId: z.string().transform(BigInt),
})
